// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@hardwoods/App/Store/Reducers";
import { getCommon } from "@hardwoods/App/Store/Selectors/CommonState";
import { color } from "@hardwoods/XDL/Utilities";
import { FC } from "react";
import * as React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

const StyledOverlayElement = styled.div<{ isVisible?: boolean; isMobile?: boolean; includeHeader?: boolean }>`
    visibility: hidden;
    opacity: 0;
    transition: opacity 450ms ease-out, visibility 450ms ease-out;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    background-color: ${color("text.main", 0.75)};
    width: 0;
    z-index: ${({ theme, isMobile, includeHeader }: any) => {
        return isMobile && includeHeader ? theme.zIndex.loadingOverlay : theme.zIndex.stickyFooter - 1;
    }};

    ${({ isVisible }) => {
        if (isVisible) {
            return `
            visibility: visible;
            opacity: 1;
            width: auto;`;
        }
    }};
`;

type Props = ReturnType<typeof mapStateToProps> & { show?: boolean; includeHeader?: boolean; forceShow?: boolean };

const mapStateToProps = (state: CustomAppState) => ({
    isVisible: getCommon(state).isPopupVisible,
    isMobile: getCommon(state).isMobile,
});

const StyledOverlay: FC<Props> = ({ isVisible, forceShow, isMobile, show, includeHeader }) => {
    return (
        <StyledOverlayElement
            isVisible={(isVisible && show) || forceShow}
            isMobile={isMobile}
            includeHeader={includeHeader}
        />
    );
};

export default connect(mapStateToProps)(StyledOverlay);
